import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

import {
  IAPI_FAC035_Request,
  IAPI_FAC035_Response,
  IAPI_FAC009_Request,
  IAPI_FAC009_Response,
} from "../../../type/apiType";

// 日々更新法人職員系の退職年月日削除職員確認API
// API仕様書_契約者
import {
  IAPI_CON031_Request,
  IAPI_CON031_Response,
  IAPI_CON030_Request,
  IAPI_CON030_Response,
} from "../../../type/apiType";

// 共済契約対象施設等一部廃止届参照API
const httpAPI_FAC035 = async (
  param: IAPI_FAC035_Request
): Promise<IAPI_FAC035_Response> => {
  let res = await http.post(ApiUrl.API_FAC035, {
    ...param,
  });

  return res.data;
};

// 共済契約対象施設等一部廃止届更新API
const httpAPI_FAC009 = async (
  param: IAPI_FAC009_Request
): Promise<IAPI_FAC009_Response> => {
  let res = await http.post(ApiUrl.API_FAC009, {
    ...param,
  });

  return res.data;
};

// 日々更新法人職員系の退職年月日削除職員確認API
const httpIAPI_CON031 = async (
  param: IAPI_CON031_Request
): Promise<IAPI_CON031_Response> => {
  const res = await http.post(ApiUrl.API_CON031, { ...param });
  return res.data;
};

// 日々更新法人職員系の退職年月日削除API
const httpIAPI_CON030 = async (
  param: IAPI_CON030_Request
): Promise<IAPI_CON030_Response> => {
  const res = await http.post(ApiUrl.API_CON030, { ...param });
  return res.data;
};

export { httpAPI_FAC035, httpAPI_FAC009, httpIAPI_CON031, httpIAPI_CON030 };
